export default "__VITE_ASSET__DzLOK3uK__"